module.exports = __webpack_public_path__ + "static/media/icon-menu-up-end-active.9698af8a.svg";